export * from './constants'
export * from './i18ns'
export * from './formStructure'
export * from './insertResource'

/** 从地址栏获取参数pageType和client_id */
export const getLocationParams = () => {
  const str = window.location.href
  // 使用正则表达式提取 pageType 的值
  const match = str.match(/[?&]pageType=([^&]*)/)
  const pageType = match ? match[1] : null
  // 使用正则表达式提取 client_id 的值
  const matchs = str.match(/[?&]client_id=([^&]*)/)
  const client_id = matchs ? matchs[1] : null
  // 使用正则表达式提取response_type 的值
  const matchs1 = str.match(/[?&]response_type=([^&]*)/)
  const response_type = matchs1 ? matchs1[1] : null
  // 使用正则表达式提取state 的值
  const matchs2 = str.match(/[?&]state=([^&]*)/)
  const state = matchs2 ? matchs2[1] : null
  // 使用正则表达式提取redirect_uri 的值
  const matchs3 = str.match(/[?&]redirect_uri=([^&]*)/)
  const redirect_uri = matchs3 ? matchs3[1] : null
  // 使用正则表达式提取casLogin 的值
  const matchs4 = str.match(/[?&]casLogin=([^&]*)/)
  const casLogin = matchs4 ? matchs4[1] : null
  return {
    pageType,
    client_id,
    response_type,
    state,
    redirect_uri,
    casLogin
  }
}